import React from 'react'

//compinents
import Navbar from './Cnavbar'
import Main from './Main'
const Category = () => {
  
  return (
     <div>
           <Navbar />
            <Main />
     </div> 
  )
}

export default Category